<nav class="flex" aria-label="Migas de pan">
  <ol
    class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
    @for (breadcrumb of items(); track breadcrumb.path) {
      @if (!$first) {
        @if (separatorType() === 'icon') {
          <mat-icon
            [svgIcon]="separator()"
            class="rtl:rotate-180 !w-3 !h-3 text-gray-400 mx-1">
          </mat-icon>
        } @else {
          <span [class]="separatorCssClass()">{{ separator() }}</span>
        }
      }

      @if ($first) {
        <ng-container
          [ngTemplateOutlet]="breadcrumbTemplate"
          [ngTemplateOutletContext]="{
            last: false,
            cssClass: firstItemCssClass(),
            breadcrumb,
          }"></ng-container>
      } @else if ($last) {
        <ng-container
          [ngTemplateOutlet]="breadcrumbTemplate"
          [ngTemplateOutletContext]="{
            last: true,
            cssClass: lastItemCssClass(),
            breadcrumb,
          }"></ng-container>
      } @else {
        <ng-container
          [ngTemplateOutlet]="breadcrumbTemplate"
          [ngTemplateOutletContext]="{
            last: false,
            cssClass: '',
            breadcrumb,
          }"></ng-container>
      }
    }
  </ol>
</nav>

<ng-template
  let-cssClass="cssClass"
  let-breadcrumb="breadcrumb"
  let-last="last"
  #breadcrumbTemplate>
  <li class="inline-flex items-center">
    <a
      [class]="itemCssClass()"
      [ngClass]="cssClass"
      [routerLink]="last ? null : breadcrumb.path">
      @if (breadcrumb.icon) {
        <mat-icon [svgIcon]="breadcrumb.icon" class="!w-4 !h-4"></mat-icon>
      }
      {{ breadcrumb.label ?? '' }}
    </a>
  </li>
</ng-template>
